import {
  AuthFormFooter,
  BackLogin,
  CenteredAuthForm,
  ErrorMessage,
  FieldWrapperWithError,
  Input,
  ResetTitle,
  SignUpButton,
  SubTitle,
} from '@Components/Auth/Auth.styled';
import { Spinner } from '@Components/common/Spinner';
import { _ForgotPassword } from '@Services/Authentication';
import { AxiosError } from 'axios';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Lock from 'public/lock.svg';
import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';

type Props = {
  setFormSuccessMessage: React.Dispatch<React.SetStateAction<string>>;
};
type ResetPasswordFormValues = {
  email: string;
};

export default function ForgotPasswordForm({ setFormSuccessMessage }: Props) {
  const { t: tAuth } = useTranslation('Auth');
  const [submitHasError, setSubmitHasError] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ResetPasswordFormValues>();

  const onSubmit: SubmitHandler<ResetPasswordFormValues> = (data) => {
    setIsLoading(true);
    _ForgotPassword({
      email: data.email.toLowerCase(),
    })
      .then(({ data }) => {
        setFormSuccessMessage(data.message);
      })
      .catch((err: AxiosError) => {
        setSubmitHasError(err.response?.data?.message || '');
        setIsLoading(false);
      });
  };

  return (
    <CenteredAuthForm onSubmit={handleSubmit(onSubmit)}>
      <Image src={Lock} width={90.47} height={115.51} alt="auth-lock" />
      <ResetTitle>{tAuth('forget_title')}</ResetTitle>
      <SubTitle>{tAuth('forget_subtitle')}</SubTitle>
      <FieldWrapperWithError>
        <Input
          disabled={isLoading}
          type="text"
          placeholder={tAuth('email')}
          {...register('email', { required: true })}
        />
        <ErrorMessage>{errors.email?.type === 'required' && tAuth('forget_error')}</ErrorMessage>
      </FieldWrapperWithError>
      <SignUpButton disabled={isLoading} variant="filled-red" type="submit">
        {isLoading ? <Spinner /> : tAuth('reset_request')}
      </SignUpButton>
      {submitHasError && <ErrorMessage>{submitHasError}</ErrorMessage>}
      <AuthFormFooter>
        <BackLogin href="/auth/login">{tAuth('back_login')}</BackLogin>
      </AuthFormFooter>
    </CenteredAuthForm>
  );
}
